import { DebtServicePath } from "utils/constants";

export const depositsRequests = {
  getDepositHistory: userUid => `${DebtServicePath}deposits/${userUid}/history`,
};
